import React from 'react';

const HeaderMenu = ({ leftChildren, centerChildren, rightChildren, style }) => {
  return (
    <div className={`header-menu header-menu--${style}`}>
      {leftChildren.length > 0 &&
        <div className='header-menu__left'>
          {leftChildren}
        </div>
      }
      {centerChildren.length > 0 &&
        <div className={`header-menu__center--${style}`}>
          {centerChildren}
        </div>
      }
      {rightChildren.length > 0 &&
        <div className='header-menu__right'>
          {rightChildren}
        </div>
      }
    </div>
  );
}

export const HeaderMenuStyles = {
  primary: 'primary',
  secondary: 'secondary',
};

HeaderMenu.defaultProps = {
  isOpen: false,
  style: HeaderMenuStyles.primary,
  leftChildren: [],
  centerChildren: [],
  rightChildren: [],
};

export default HeaderMenu;